function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM8.704 12.608V13.6H7.304V12.568C6.712 12.424 5.392 11.952 4.888 10.2L6.208 9.664C6.256 9.84 6.672 11.336 8.128 11.336C8.872 11.336 9.712 10.952 9.712 10.048C9.712 9.28 9.152 8.88 7.888 8.424C7.008 8.112 5.208 7.6 5.208 5.776C5.208 5.696 5.216 3.856 7.304 3.408V2.4H8.704V3.392C10.176 3.648 10.712 4.824 10.832 5.176L9.568 5.712C9.48 5.432 9.096 4.64 8.048 4.64C7.488 4.64 6.6 4.936 6.6 5.752C6.6 6.512 7.288 6.8 8.712 7.272C10.632 7.936 11.12 8.912 11.12 10.032C11.12 12.136 9.12 12.536 8.704 12.608Z",
  fill: "currentColor"
}));

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

var SvgIconReferrral = function SvgIconReferrral(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconReferrral, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-referrral.1ec65e15.svg";
export { ForwardRef as ReactComponent };